<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <router-link tag="button" :to="{name: 'teams.create'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
                    Novo
                </router-link>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Nome</th>
                                        <th>Gerente</th>
                                        <th>Supervisor</th>
                                        <th>Pós Venda</th>
                                        <th>Vendedores</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-show="items.length > 0"
                                        v-for="iterator in items" 
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td>{{ iterator.name }}</td>
                                        <td>{{ iterator.manager ? iterator.manager.name : '-' }}</td>
                                        <td>{{ iterator.supervisor ? iterator.supervisor.name : '-' }}</td>
                                        <td>{{ iterator.after_sale ? iterator.after_sale.name : '-' }}</td>
                                        <td>{{ iterator.salesmans.length }}</td>
                                        <td class="td-actions text-right">
                                            <index-buttons
                                                :iterator=iterator
                                                :showAudit="true"
                                                :toAudit="{name: 'teams.index'}"
                                                :showEdit="true"
                                                :toEdit="{name: 'teams.edit', params: { id: iterator.id }}"
                                                :showRemove="true"
                                                dispatchRemove="teams/rem"
                                                :callbackRemove="getData">
                                            </index-buttons>
                                    </td>
                                </tr>
                                <tr v-show="items.length==0">
                                    <td colspan="7">Nenhuma equipe encontrada!</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {
            items: {
                set(_itens) {
                    this.$store.commit('teams/setList', []);
                },
                get(){
                    return this.$store.state.teams.itens;
                }
            }

        },
        created: function () {
            this.items = [];
            this.getData();
        },
        methods: {
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            }
        }
    }
</script>
